<template>
	<div class="list-item-with-title">
		<f7-block-title>{{ title }}</f7-block-title>
		<f7-list dividers-ios strong-ios outline-ios>
			<f7-list-item
				:class="['f7-list-item', { placeholder: !text && placeholder }]"
				:no-chevron="!showChevron"
				:disabled="loading"
				@click="handleItemClick"
				:title="text || placeholder || ''"
				:link="link"
			>
				<template v-if="media" #media>
					<img :src="media" alt="">
				</template>
				<template v-if="loading" #after>
					<f7-preloader :size="16"/>
				</template>
			</f7-list-item>
			<p ref="errorEl" v-if="error" class="list-item-with-title_error">{{ errorText }}</p>
		</f7-list>
	</div>
</template>

<script setup lang="ts">
import {ref} from "vue";

interface Props {
	showChevron?: boolean;
	link?: string | boolean;
	title?: string;
	placeholder?: string;
	text?: string;
	loading?: boolean;
	media?: string;
}

interface Emits {
	(e: 'onItemClick'): void;
}

withDefaults(defineProps<Props>(), {
	showChevron: true,
	link: '#'
})

const emits = defineEmits<Emits>();

const handleItemClick = () => {
	emits('onItemClick');
}

const errorEl = ref(null);
const error = ref(false);
const errorText = ref("");

defineExpose({error, errorEl, errorText})
</script>

<style lang="scss">
.list-item-with-title {
	.block-title {
		text-transform: uppercase;
		@include text(12px, 400, var(--grey2), 14.4px);
	}

	.item-title {
		line-height: 16px !important;
	}

	.f7-list-item {
		&.placeholder {

			.item-title {
				color: #999;
			}
		}
	}

	--f7-list-item-media-margin: 8px;

	.item-media {
		img {
			width: 24px;
			height: 24px;
		}
	}

	&_error {
		padding: 6px 16px;
		@include text(12px, 400, var(--red1), 14.4px);
	}
}
</style>
